module.exports = __webpack_public_path__ + "static/img/kitten_router.e32db7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kitten_router.png
// module id = i4Aj
// module chunks = 1